import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.48101 14.5159L11.9114 20.9968H12.7215L19 5.6047L18.3924 5L3 11.2755V12.0856L9.48101 14.5159Z"
    fill="inherit"
  />,
  'LocationFillIcon',
)
